module.exports = __webpack_public_path__ + "static/media/threatIcon.126c979e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/threatIcon.png
// module id = 1491
// module chunks = 0